import additionalCommissionsService from '../../services/voucher/additional-commissions-service';
import { deleteTaxAllocationsForDeal } from './tax-allocations-actions';
import {
  selectTaxAdditionalCommissions,
  TAX_ADDITIONAL_COMMISSION_TYPES,
  selectTotalCommissions,
} from '../selectors/voucher-selectors';

import {
  CREATE_ADDITIONAL_COMMISSIONS_SUCCESS,
  DELETE_ADDITIONAL_COMMISSIONS_SUCCESS,
  FETCH_ADDITIONAL_COMMISSIONS_BY_DEAL_ID_SUCCESS,
  FETCH_VOUCHER_OPTIONS_SUCCESS,
  UPDATE_ADDITIONAL_COMMISSIONS_SUCCESS,
} from './action-types';
import { updateFinancials, updateLoadedFinancials, FINANCIAL_TYPES } from './financial-actions';

// action creators
const createAdditionalCommissionSuccess = additionalCommission => ({
  type: CREATE_ADDITIONAL_COMMISSIONS_SUCCESS,
  payload: additionalCommission,
});

const deleteAdditionalCommissionSuccess = id => ({
  type: DELETE_ADDITIONAL_COMMISSIONS_SUCCESS,
  payload: id,
});

const fetchAddtionalCommissionTypeOptionsSuccess = options => ({
  type: FETCH_VOUCHER_OPTIONS_SUCCESS,
  payload: { additionalCommissionTypeOptions: options },
});

const fetchAdditionalCommissionsSuccess = commissions => ({
  type: FETCH_ADDITIONAL_COMMISSIONS_BY_DEAL_ID_SUCCESS,
  payload: commissions,
});

const updateAdditionalCommissionSuccess = commission => ({
  type: UPDATE_ADDITIONAL_COMMISSIONS_SUCCESS,
  payload: commission,
});

// dispatches
const fetchAdditionalCommissionTypeOptions = () => dispatch =>
  additionalCommissionsService.fetchAdditionalCommissionTypeOptions()
    .then(options => dispatch(fetchAddtionalCommissionTypeOptionsSuccess(options)))
    .catch(() => console.error('Error fetching additional commission type options'));

const createAdditionalCommission = post => dispatch =>
  additionalCommissionsService.createCommission(post)
    .then(res => dispatch(createAdditionalCommissionSuccess(res)))
    .catch(() => console.error('Error creating additional commission'));

const clearTaxAllocationsWhenNoTaxCommissions = (dispatch, getState, dealId) => (
  selectTaxAdditionalCommissions(getState()).length
    ? Promise.resolve()
    : dispatch(deleteTaxAllocationsForDeal(dealId))
);

const deleteAdditionalCommission = (id, options = {}) => (dispatch, getState) => {
  const deletedCommission = getState().voucherAdditionalCommissions.additionalCommissions
    .find(additionalCommission => additionalCommission.id === id);
  const previousTotal = selectTotalCommissions(getState());

  const triggerFinancialRecalculation = (dealId) => {
    if (options.updateLoadedFinancialsOnly) {
      return dispatch(updateLoadedFinancials(dealId, FINANCIAL_TYPES.ADDITIONAL_COMMISSION, previousTotal, {
        skipDealAndTimestampUpdate: true,
      }));
    }
    return dispatch(updateFinancials(dealId, FINANCIAL_TYPES.ADDITIONAL_COMMISSION));
  };

  return additionalCommissionsService.deleteCommission(id)
    .then(() => {
      dispatch(deleteAdditionalCommissionSuccess(id));
      if (
        deletedCommission
        && TAX_ADDITIONAL_COMMISSION_TYPES.includes(deletedCommission.acommission_type)
      ) {
        return clearTaxAllocationsWhenNoTaxCommissions(dispatch, getState, deletedCommission.transaction)
          .then(() => triggerFinancialRecalculation(getState().deal.deal.id));
      }
      return triggerFinancialRecalculation(getState().deal.deal.id);
    })
    .catch(() => console.error('Error deleting consideration'));
};

const fetchAdditionalCommissions = params => dispatch =>
  additionalCommissionsService.fetchCommissions(params)
    .then(commissions => dispatch(fetchAdditionalCommissionsSuccess(commissions)))
    .catch(() => console.error('Error fetching considerations'));

const updateAdditionalCommissions = (id, params, options = {}) => (dispatch, getState) => {
  const previousTotal = selectTotalCommissions(getState());
  return additionalCommissionsService.patchCommission(id, params)
    .then((res) => {
      dispatch(updateAdditionalCommissionSuccess(res));
      if ('acommission_type' in params && !selectTaxAdditionalCommissions(getState()).length) {
        return dispatch(deleteTaxAllocationsForDeal(res.transaction))
          .then(() => {
            if (options.updateLoadedFinancialsOnly) {
              return dispatch(updateLoadedFinancials(
                res.transaction,
                FINANCIAL_TYPES.ADDITIONAL_COMMISSION,
                previousTotal,
                { force: true, skipDealAndTimestampUpdate: true },
              ));
            }
            return dispatch(updateFinancials(res.transaction, FINANCIAL_TYPES.ADDITIONAL_COMMISSION));
          });
      }
      if ('commission_amount' in params) {
        if (options.updateLoadedFinancialsOnly) {
          return dispatch(updateLoadedFinancials(
            res.transaction,
            FINANCIAL_TYPES.ADDITIONAL_COMMISSION,
            previousTotal,
            { force: true, skipDealAndTimestampUpdate: true },
          ));
        }
        return dispatch(updateFinancials(res.transaction, FINANCIAL_TYPES.ADDITIONAL_COMMISSION));
      }
      return null;
    })
    .catch(() => console.error('Error updating consideration'));
};

export {
  createAdditionalCommission,
  deleteAdditionalCommission,
  fetchAdditionalCommissionTypeOptions,
  fetchAdditionalCommissions,
  updateAdditionalCommissions,
};
